export const COL_SEPARATOR = ';';
export const ROW_SEPARATOR = '\r\n';

export const escapeField = f => `"${String(f).replace(/"/g, '""')}"`;

/**
 * Generate a CSV encoded string from arrays
 *
 * @param {Array<String>} headerArray - The title for each column
 * @param {Array<Array<String>>} bodyEntries - Entries
 *
 * @returns {String} CSV-Encoded string
 */
export function generate(headerArray, bodyEntries) {
  const header = headerArray.map(escapeField).join(COL_SEPARATOR);
  const body = bodyEntries
    .map(line => line.map(escapeField).join(COL_SEPARATOR))
    .join(ROW_SEPARATOR);

  return [header, body].join(ROW_SEPARATOR);
}

export default generate;
